// Global Instructions Rule Applied!
import React from 'react'
import { List, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircle } from '@fortawesome/free-solid-svg-icons'
import { text, dateText, userEntryLabel } from '../lib/format.ts'

/**
 * Read-only task rows (done state, subject, due date, assignees) shared by the deal and
 * company detail screens. Rows are TaskRecord-shaped (`tasks__*` + `prog__task_assignees`,
 * whose entries are contact-shaped UserEntries).
 */
export function TaskList({ tasks }: { tasks: any[] }): React.JSX.Element {
  if (tasks.length === 0) return <Typography.Text type="secondary">No tasks.</Typography.Text>
  return (
    <List
      size="small"
      dataSource={tasks}
      rowKey={(t: any) => String(t.tasks__id)}
      renderItem={(t: any) => {
        const done = Boolean(t.tasks__completed)
        const assignees = (Array.isArray(t.prog__task_assignees) ? t.prog__task_assignees : [])
          .map(userEntryLabel)
          .filter(Boolean)
        const meta = [t.tasks__due_by ? `Due ${dateText(t.tasks__due_by)}` : null, assignees.join(', ') || null]
          .filter(Boolean)
          .join('  ·  ')
        return (
          <List.Item style={{ paddingLeft: 4, paddingRight: 4, alignItems: 'flex-start' }}>
            <List.Item.Meta
              avatar={
                <FontAwesomeIcon
                  icon={done ? faCircleCheck : faCircle}
                  style={{ color: done ? '#52c41a' : 'rgba(0,0,0,0.2)', marginTop: 4 }}
                />
              }
              title={
                <span style={{ textDecoration: done ? 'line-through' : undefined, color: done ? 'rgba(0,0,0,0.45)' : undefined }}>
                  {text(t.tasks__subject)}
                </span>
              }
              description={meta || undefined}
            />
          </List.Item>
        )
      }}
    />
  )
}
